module.exports = __webpack_public_path__ + "static/media/closed-mail.d538d69d.svg";